export default __webpack_public_path__ + "static/media/cagette-pain-bio.ac0437af.png";